import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
}: SEOProps) {
  const location = useLocation();
  const baseUrl = 'https://goldroute.github.io';

  const defaultTitle = 'jm天堂 - 官方入口与完整使用指南';
  const defaultDescription =
    'jm天堂是深受用户喜爱的内容平台，本页为您提供jm天堂的官方入口、最新地址、使用教程及常见问题解答，帮助您快速访问jm天堂，畅享丰富内容资源。';
  const defaultKeywords = 'jm天堂,jm天堂官方入口,jm天堂最新地址,jm天堂使用教程,jm天堂访问方法,jm天堂常见问题,jm天堂资源';

  const pageTitle = title || defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;
  const pageUrl = canonicalUrl || `${baseUrl}${location.pathname}`;
  const pageOgImage = ogImage || `${baseUrl}/og-image.jpg`;

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDescription);
    setMeta('keywords', pageKeywords);
    setMeta('og:title', pageTitle, true);
    setMeta('og:description', pageDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', pageUrl, true);
    setMeta('og:image', pageOgImage, true);
    setMeta('og:site_name', 'jm天堂官方指南', true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', pageTitle);
    setMeta('twitter:description', pageDescription);
    setMeta('twitter:image', pageOgImage);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', pageUrl);
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = pageUrl;
      document.head.appendChild(link);
    }

    return () => {
      document.title = defaultTitle;
    };
  }, [pageTitle, pageDescription, pageKeywords, pageUrl, ogType, pageOgImage]);

  return null;
}